import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import TuiSelect from '../Select';
import TuiOption from '../Option';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimepickerH5',
  props: {
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string;
};




const currentValue = ref();
watch(
  () => props.value,
  val => {
    if (!val) return;
    currentValue.value = val;
  },
  { immediate: true }
);
watch(currentValue, val => emit('input', val), { immediate: true });

const getTimeList = () => {
  const options: string[] = [];
  for (let i = 0; i < 24; i++) {
    for (let j = 0; j < 60; j += 15) {
      const hour = i < 10 ? `0${i}` : `${i}`;
      const minute = j < 10 ? `0${j}` : `${j}`;
      options.push(`${hour}:${minute}`);
    }
  }
  return options;
};
const timeOptions = getTimeList();

const list = timeOptions.map(item => ({
  label: item,
  value: item,
}));

return { __sfc: true,props, emit, currentValue, getTimeList, timeOptions, list, TuiSelect, TuiOption }
}

})